import React from 'react';

const MoreVertical = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 16" {...props}>
    <path
      fillRule="evenodd"
      d="M2 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </svg>
);

export default MoreVertical;
